import ConsentCheckbox from 'conversations-visitor-message-history/email-capture/ConsentCheckbox';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import VizExLoadingButton from 'visitor-ui-component-library/button/VizExLoadingButton';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CIRRUS, EERIE, GYPSUM } from 'visitor-ui-component-library/constants/WidgetColors';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { ChatWidgetLocaleContextConsumer } from './ChatWidgetLocaleContext';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ConsentPrompt__Container",
  componentId: "gm05c6-0"
})(["border-top:", ";display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:12px 28px;position:relative;background:", ";"], props => props.$isOutsideChat ? '0' : `2px solid ${CIRRUS}`, GYPSUM);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentPrompt__SmallNoParagraphPadding",
  componentId: "gm05c6-1"
})(["display:block;line-height:24px;word-break:break-word;word-wrap:break-word;-ms-word-break:break-all;p{margin-bottom:0;}"]);
const FullWidthButton = styled(VizExButton).withConfig({
  displayName: "ConsentPrompt__FullWidthButton",
  componentId: "gm05c6-2"
})(["margin:0 auto;width:fit-content;flex:0 0 auto;border-radius:999px;"]);
const FlexWrapper = styled.div.withConfig({
  displayName: "ConsentPrompt__FlexWrapper",
  componentId: "gm05c6-3"
})(["display:flex;flex-direction:column;width:100%;margin:12px 0 8px 0;"]);
const CheckboxWrapper = styled.div.withConfig({
  displayName: "ConsentPrompt__CheckboxWrapper",
  componentId: "gm05c6-4"
})(["margin-bottom:8px;"]);
const ConsentPrompt = ({
  message,
  checkboxLabel,
  onClick,
  onClose = () => {},
  showButton,
  isPortal53 = false,
  isOutsideChat = false
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [checked, setChecked] = useState(!checkboxLabel);
  const onClickWrapper = () => {
    onClick();
    setSubmitting(true);
  };
  const onCheckboxChange = e => {
    setChecked(e.target.checked);
  };
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": "gdpr-consent-prompt",
    dir: "auto",
    $isOutsideChat: isOutsideChat,
    className: !showButton ? 'm-bottom-4' : undefined,
    children: [!showButton && isPortal53 && /*#__PURE__*/_jsx(VizExCloseButton, {
      size: 'sm',
      onClick: onClose,
      theme: isOutsideChat ? createThemeV2({
        colors: {
          text: EERIE
        }
      }) : createThemeV2()
    }), /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      "data-test-id": "gdpr-consent-text",
      dangerouslySetInnerHTML: {
        __html: formatHtml(message)
      }
    }), showButton && /*#__PURE__*/_jsxs(FlexWrapper, {
      children: [!!checkboxLabel && /*#__PURE__*/_jsx(CheckboxWrapper, {
        children: /*#__PURE__*/_jsx(ConsentCheckbox, {
          isChecked: checked,
          message: checkboxLabel,
          onChange: onCheckboxChange
        })
      }), /*#__PURE__*/_jsx(VizExLoadingButton, {
        currentState: submitting ? 'submitting' : 'ready',
        Button: FullWidthButton,
        "data-test-id": "gdpr-consent-agree-button",
        onClick: onClickWrapper,
        disabled: !checked,
        children: /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
          children: locale => /*#__PURE__*/_jsx(FormattedMessage, {
            message: checkboxLabel ? 'conversations-visitor-experience-components.buttons.submit' : 'conversations-visitor-experience-components.buttons.agree',
            options: {
              locale
            }
          })
        })
      })]
    })]
  });
};
ConsentPrompt.propTypes = {
  isOutsideChat: PropTypes.bool,
  isPortal53: PropTypes.bool,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showButton: PropTypes.bool.isRequired
};
ConsentPrompt.displayName = 'ConsentPrompt';
export default ConsentPrompt;